/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import Iframe from 'react-iframe'
import {Badge, Card, CardBody, Col, Container, Row} from "shards-react";
import MetaTags from 'react-meta-tags';
import PageTitle from "../components/common/PageTitle";
import { RWebShare } from "react-web-share";

class Disclaimer extends React.Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4" style={{height:"100%"}}>
        <MetaTags>
          <meta property="og:title" content={"Disclaimer JetsoHub 著數盒子"} />
          <meta property="og:site_name" content="JetsoHub 著數盒子"/>
          <meta property="og:type" content="article"/>
          <title>{"Disclaimer JetsoHub 著數盒子"}</title>
        </MetaTags>
        <div className="entry"><h1 className="page-title">免責聲明</h1><p>Disclaimer
          版權及免責聲明</p><p>https://jetsohub.gitlab.io/
          （下稱「本網站」）絕對保護及尊重他人的知識產權及版權。如任何人士、商戶或機構發現本網站有任何侵權行為，請透過電郵聯絡本網站。瀏覽本網站，即表示你已無條件接受及同意此版權告示的條款，以及本網站在毋須事先通知的情況下而可隨時作出的修改及／或增補。</p>
          <p>本網站所載資料取自經認為屬可靠的來源，但並未經本網站獨立核證。所有提供的資料只供參考之用，本網站會盡力確保提供最準確的資料，但本網站不能擔保或保證該等資料及／或內容均為準確無誤。在個別情況下，某部份資料及／或一些指向其他網站的連結仍可能與最新的情況有所不同，這些網頁並不是由本公司所控制。對於因資料誤編／內容疏漏而直接或間接引致的損失、損害、費用或開支，本網站不會承擔任何形式的法律責任。</p>
          <p>本網站亦可能載有由其他人士、商戶或機構所提供的資料，而本網站對有關方面以及對該等資料並無影響力。使用者可從本網站連結至由其他商戶或機構所提供的網站。本網站對於該等資料亦不承擔任何責任或法律責任（不論該等責任是如何導致的）。</p>
          <p>即使本網站與其他商戶或機構網站設有連結安排，亦不表示本網站認同該等網站所登載的內容。本網站所顯示的商標，由本網站及其他相關方擁有。未經本網站或該等相關方之書面同意，不可使用此等商標。未經本網站事前以書面同意，不可將此等材料的任何部分修改、翻版、（以任何形式或方式）傳送、複製、分發或以任何其他方式作商業用途。</p>
          <p>在毋須事先通知的情況下，本網站保留隨時更新本免責聲明的權利，任何更改於本網站發佈時，即時生效。請閣下在每次瀏覽本網站時，務必查看此免責聲明。如閣下繼續使用本網站，即代表閣下同意接受更改後的免責聲明約束。</p>
          <p>修訂日期：2022年1月27日</p>
          <div className="clear"></div>
          </div>
      </Container>
    );
  }
}

export default Disclaimer;
